<template>
  <div>
    <!-- Agents Performance -->
    <b-row>
      <b-col md="12">
        <sikanii-list-page
          title="Agent Performance"
          :rows="agentsList"
          :columns="agentFields"
          :table-loading="loadingAgents"
          show-profile-photo
        >
          <template slot="right-extra-header-actions">
            <div
              class="d-flex align-self-center align-items-center"
            >
              <sikanii-select
                v-model="selectedAgentTop"
                :options="topOptions"
                label-name="text"
                value-name="value"
                placeholder="Performance Type"
              />
            </div>
          </template>
          <template #total_amount="{row}">
            {{$store.getters['auth/currency']}}{{row.item.total_amount | currency}}
          </template>
        </sikanii-list-page>
      </b-col>
    </b-row>

    <!-- Top Items -->
    <b-row class="mt-2">
      <b-col md="12">
        <sikanii-list-page
          title="Item Performance"
          :rows="itemsList"
          :columns="itemFields"
          :table-loading="loadingItems"
          show-profile-photo
        >
          <template slot="right-extra-header-actions">
            <div
              class="d-flex align-self-center align-items-center"
            >
              <sikanii-select
                v-model="selectedItemTop"
                :options="topOptions"
                label-name="text"
                value-name="value"
                placeholder="Performance Type"
              />
            </div>
          </template>
          <template #total_amount="{row}">
            {{ $store.getters['auth/currency'] }}{{ row.item.total_amount | currency }}
          </template>
        </sikanii-list-page>
      </b-col>
    </b-row>

    <!-- Delinquent Contracts -->
    <b-row class="mt-2">
      <b-col md="12">
        <sikanii-list-page
          title="Overdue Contracts"
          :rows="delinquentList"
          :columns="delinquentFields"
          :table-loading="loading"
          show-profile-photo
        >
          <template #overdue_amount="{row}">
            {{ $store.getters['auth/currency'] }}{{ row.item.overdue_amount | currency }}
          </template>
        </sikanii-list-page>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SikaniiListPage from '@/layouts/components/SikaniiListPage.vue'
import SikaniiSelect from '@/layouts/components/SikaniiSelect.vue'

export default {
  components: {
    SikaniiSelect,
    SikaniiListPage,
  },

  data() {
    return {
      loading: false,
      loadingAgents: false,
      loadingItems: false,
      topOptions: [
        { value: 'yes', text: 'Best Performance' },
        { value: 'no', text: 'Worst Performance' },
      ],
      selectedItemTop: 'yes',
      selectedAgentTop: 'yes',

      agentFields: [
        { key: 'index', label: '#' },
        { key: 'photo', label: 'Agent Photo' },
        { key: 'name', label: 'Agent Name' },
        { key: 'total_items', label: 'Items Sold' },
        { key: 'total_amount', label: 'Total Value' },
      ],

      itemFields: [
        { key: 'index', label: '#' },
        { key: 'photo', label: 'Item Photo' },
        { key: 'name', label: 'Item Name' },
        { key: 'total_quantity', label: 'Quantity Sold' },
        { key: 'total_amount', label: 'Total Value' },
      ],

      delinquentFields: [
        { key: 'index', label: '#' },
        { key: 'contract_id', label: 'Contract ID' },
        { key: 'photo', label: 'Photo' },
        { key: 'name', label: 'Name' },
        { key: 'overdue_amount', label: 'Overdue Amount' },
        { key: 'days_overdue', label: 'Days Overdue' },
      ],

      agentsList: [],
      itemsList: [],
      delinquentList: [],
    }
  },

  watch: {
    selectedItemTop() {
      this.fetchItemsData()
    },
    selectedAgentTop() {
      this.fetchAgentsData()
    },
  },

  mounted() {
    this.fetchAllData()
  },

  methods: {
    async fetchAllData() {
      try {
        await Promise.all([
          this.fetchAgentsData(),
          this.fetchItemsData(),
          this.fetchDelinquentData(),
        ])
      } catch (error) {
        console.error('Error fetching performance data:', error)
      }
    },

    async fetchAgentsData() {
      try {
        this.loadingAgents = true
        const response = await this.$http.get(`hire-purchase/dashboard/performance?performance_type=agent&top=${this.selectedAgentTop}`)
        this.agentsList = response.data
      } catch (error) {
        console.error('Error fetching agents data:', error)
      } finally {
        this.loadingAgents = false
      }
    },

    async fetchItemsData() {
      try {
        this.loadingItems = true
        const response = await this.$http.get(`hire-purchase/dashboard/performance?performance_type=item&top=${this.selectedItemTop}`)
        this.itemsList = response.data
      } catch (error) {
        console.error('Error fetching items data:', error)
      } finally {
        this.loadingItems = false
      }
    },

    async fetchDelinquentData() {
      try {
        this.loading = true
        const response = await this.$http.get('hire-purchase/dashboard/performance/overdue')
        this.delinquentList = response.data
      } catch (error) {
        console.error('Error fetching delinquent data:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>

</style>
